import { TOP_GAMES_CATEGORY_ID } from '@/consts/topGamesCategory';
import { isStaging } from '@/libs/getEnvironment';
import { categoryQueryOptions } from './categories';
import { gameQueryOptions } from './games/games.queries';
import { providerQueryOptions } from './providers';
import { PUBLIC_QUERY_STALE_TIME } from './queryOptions.helpers';

export const TOP_GAMES_LIMIT = 10;

export const topGamesQueryOptions = () => gameQueryOptions.list({
  params: {
    page: 1,
    limit: TOP_GAMES_LIMIT,
    filters: {
      categoryId: TOP_GAMES_CATEGORY_ID,
    },
    sort: {
      order: 'desc',
    },
  },
  options: {
    enabled: isStaging(),
    staleTime: PUBLIC_QUERY_STALE_TIME,
  },
});

export const topGamesPrefetchQueryOptions = () => isStaging() ? topGamesQueryOptions() : null;

export const bestProvidersQueryOptions = () => providerQueryOptions.list(
  { page: 1, limit: 12, filters: { isActive: true } },
  { staleTime: PUBLIC_QUERY_STALE_TIME },
);

export const categoryProvidersSliderQueryOptions = () => providerQueryOptions.list(
  { page: 1, limit: 3, filters: { isActive: true } },
  { staleTime: PUBLIC_QUERY_STALE_TIME },
);

export const otherCategoriesSliderQueryOptions = () => categoryQueryOptions.list(
  {
    page: 1,
    limit: 10,
    sort: {
      order: 'asc',
    },
  },
  { staleTime: PUBLIC_QUERY_STALE_TIME },
);
